export class Vendor {

    vendorID: number;
    vendorName: string;
    vendorAddress1: string;
    vendorAddress2: string;
    addressZipCode: string;
    vendorPhone: string;
    locationX: number;
    locationY: number;
    state: string;
    openClosed: string;
    regionID: number;
    region: {
        regionID: number;
        regionName: string;
    };
    municipalityID: number;
    municipality: {
        municipalityID: number;
        municipalityName: string;
    };
    addressFull: string;

    constructor() {

    }
}
